import React from 'react';
import styles from './Form.module.scss';

type FormCountProps = {
  label: string;
  count: number;
  minCount?: number;
  maxCount?: number;
  handleIncrease?: () => void;
  handleDecrease?: () => void;
  handleNumberChange?: (count: number) => void;
}

const FormCount: React.FC<FormCountProps> = ({
  label,
  count,
  minCount,
  maxCount,
  handleIncrease = () => {},
  handleDecrease = () => {},
  handleNumberChange = () => {},
}) => {
  const increase = () => {
    if (maxCount && count >= maxCount) {
      return;
    }
    handleIncrease();
    handleNumberChange(count + 1);
  };

  const decrease = () => {
    if (minCount && count <= minCount) {
      return;
    }
    handleDecrease();
    handleNumberChange(count - 1);
  };

  return (
    <div className={styles['form-count']}>
      <span className={styles['form-count__label']}>{label}</span>
      <div className={styles['form-count__counter']}>
        <button
          type="button"
          className={`${styles['form-count__button']} ${styles['form-count__button--decrement']} ${count === minCount ? styles['muted'] : ''}`}
          onClick={() => decrease()}
          disabled={minCount && count <= minCount}
        >
          <i className="fa fa-minus fa-sm"></i>
        </button>
        <span className={styles['form-count__value']}>{count}</span>
        <button
          type="button"
          className={`${styles['form-count__button']} ${styles['form-count__button--increment']}`}
          onClick={() => increase()}
          disabled={maxCount && count >= maxCount}
        >
          <i className="fa fa-plus fa-sm"></i>
        </button>
      </div>
    </div>
  );
};

export default FormCount;
